module.exports = __webpack_public_path__ + "img/list_Character_sq_15.e5bd50e1.jpeg";